import { Button, Table, Tooltip } from "antd";
import ContextMenu from "@/components/containers/ContextMenu";
import CopyableText from "@/components/ui/СopyableText";
import ExternalLinkIcon from "@/icons/ExternalLinkIcon";
import routes from "@/routes";

// Таблица рабочих групп типа заявки
const RequestUnitsTable = ({
  data = [],
  loading,
  onEditUnit,
  onDeleteUnit,
  requestUuid,
  isDeleted = false,
  isHidden = false,
  isPublic = true,
}) => {
  const columns = [
    {
      title: "",
      width: 48,
      align: "center",
      key: "copy",
      render: (_, item) => {
        if (isDeleted || isHidden || !isPublic) return null;
        const link = `${window.location.origin}/request-form/${requestUuid}/${item.unit_uuid}`;

        return (
          <CopyableText text={link}>
            <span style={{ display: "none" }}>{link}</span>
          </CopyableText>
        );
      },
    },
    {
      title: "",
      width: 48,
      align: "center",
      key: "preview",
      render: (_, item) => {
        if (isDeleted) return null;

        return (
          <Tooltip title="Предпросмотр">
            <Button
              type="link"
              style={{color: "#bbb"}}
              icon={<ExternalLinkIcon />}
              onClick={() => {
                const link = routes.administration.requestPreview(
                  requestUuid,
                  item.unit_uuid,
                );
                window.open(link, "_blank");
              }}
            />
          </Tooltip>
        );
      },
    },
    {
      title: "Рабочая группа",
      dataIndex: "name",
      key: "name",
      width: 250,
      ellipsis: { showTitle: false },
      render: (_, item) => (
        <Tooltip placement="bottomLeft" title={item.unit_name}>
          {item.unit_name}
        </Tooltip>
      ),
    },
    {
      title: "Название подразделения",
      dataIndex: "unit_displayed_name",
      key: "unit_displayed_name",
      width: 200,
      ellipsis: { showTitle: false },
      render: (_, item) => (
        <Tooltip placement="bottomLeft" title={item.unit_displayed_name}>
          {item.unit_displayed_name}
        </Tooltip>
      ),
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      ellipsis: { showTitle: false },
      width: 400,
      render: (_, item) => (
        <Tooltip placement="bottomLeft" title={item.comment}>
          {item.comment}
        </Tooltip>
      ),
    },
    {
      title: "",
      width: 48,
      align: "center",
      fixed: "right",
      key: "actions",
      render: (_, item) =>
        !isDeleted ? (
          <ContextMenu
            vertical
            onEdit={() => onEditUnit(item)}
            onDelete={() => onDeleteUnit(item)}
          />
        ) : null,
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={false}
      // onChange={onChange}
      size="small"
      scroll={{ x: "100%" }}
    />
  );
};

export default RequestUnitsTable;
